export default "__VITE_ASSET__cc5b001e__"